import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./app.html";
class App extends LightningElement {
  constructor() {
    super();
    this.tabEnableStr = '';
    this.enableConfigMigration = () => {
      this.template.querySelector('div[data-my-id="configMigration"]').style.display = 'block';
      this.template.querySelector('div[data-my-id="autoConfigarator"]').style.display = 'none';
      this.template.querySelector('li[data-my-id="configMigrationLi"]').classList.add('slds-is-active');
      this.template.querySelector('li[data-my-id="autoConfiguratorLi"]').classList.remove('slds-is-active');
    };
    this.enableAutoConfigurator = () => {
      this.template.querySelector('div[data-my-id="configMigration"]').style.display = 'none';
      this.template.querySelector('div[data-my-id="autoConfigarator"]').style.display = 'block';
      this.template.querySelector('li[data-my-id="autoConfiguratorLi"]').classList.add('slds-is-active');
      this.template.querySelector('li[data-my-id="configMigrationLi"]').classList.remove('slds-is-active');
    };
    const baseURI = this.template.baseURI;
    const queryParams = baseURI.split('?');
    if (queryParams.length > 1) {
      this.tabEnableStr = queryParams[1];
    }
  }
  renderedCallback() {
    switch (this.tabEnableStr) {
      case 'migrator':
        this.enableConfigMigration();
        break;
      case 'configurator':
        this.enableAutoConfigurator();
        break;
      default:
        this.enableConfigMigration();
    }
  }
}
_registerDecorators(App, {
  fields: ["tabEnableStr", "enableConfigMigration", "enableAutoConfigurator"]
});
export default _registerComponent(App, {
  tmpl: _tmpl
});